import { withRouter, Link } from 'react-router-dom';
import { MenuItem } from 'react-bootstrap';
/* eslint-disable react/prop-types */ // TODO: add props

const NavItemLink = ({ to, location, anchor, children }) => {
  const dynamicProps = {};

  if (!anchor) {
    dynamicProps.to = to;
    dynamicProps.componentClass = Link;
  }

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <MenuItem
      href={to}
      active={isActive(to)}
      onSelect={() => {
        // hacky force the menu to close
        document.dispatchEvent(new window.MouseEvent('click'));
      }}
      {...dynamicProps}
    >
      {children}
    </MenuItem>
  );
};

export default withRouter(NavItemLink);
